const COLORS = { red: "#FF3B3B", yellow: "#FFB800", green: "#00C853" };

const wrap = (ctx, text, maxWidth, maxLines) => {
  const words = text.split(" ");
  const lines = [];
  let line = "";
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = w;
    } else line = test;
    if (lines.length === maxLines) break;
  }
  if (lines.length < maxLines && line) lines.push(line);
  if (lines.length === maxLines && words.join(" ") !== lines.join(" ")) lines[maxLines - 1] = lines[maxLines - 1].replace(/\s*\S*$/, "…");
  return lines;
};

// Renders a 1080x1080 scorecard PNG and resolves to a Blob.
export async function renderScorecard(data, siteUrl) {
  try {
    await document.fonts?.load?.("800 80px Outfit");
    await document.fonts?.load?.("500 32px 'IBM Plex Mono'");
  } catch {}
  const S = 1080;
  const canvas = document.createElement("canvas");
  canvas.width = S;
  canvas.height = S;
  const ctx = canvas.getContext("2d");
  const accent = COLORS[data.overallRating] || COLORS.yellow;
  const score = Number(data.overallScore) || 0;

  ctx.fillStyle = "#080C0A";
  ctx.fillRect(0, 0, S, S);
  const glow = ctx.createRadialGradient(S * 0.78, S * 0.3, 20, S * 0.78, S * 0.3, 520);
  glow.addColorStop(0, `${accent}33`);
  glow.addColorStop(1, "rgba(0,0,0,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, S, S);

  ctx.fillStyle = "#A8FF3E";
  ctx.beginPath();
  ctx.roundRect(72, 72, 56, 56, 14);
  ctx.fill();
  ctx.fillStyle = "#07130a";
  ctx.font = "800 34px Outfit, sans-serif";
  ctx.fillText("W", 85, 113);
  ctx.fillStyle = "#F8FAF9";
  ctx.font = "700 40px Outfit, sans-serif";
  ctx.fillText("WhatIs", 148, 112);
  const w1 = ctx.measureText("WhatIs").width;
  ctx.fillStyle = "#A8FF3E";
  ctx.fillText("Inside", 148 + w1, 112);

  ctx.fillStyle = "#5C6E64";
  ctx.font = "500 24px 'IBM Plex Mono', monospace";
  const meta = [data.brand, data.category].filter(Boolean).join("  ·  ").toUpperCase();
  ctx.fillText(meta, 72, 230);

  ctx.fillStyle = "#F8FAF9";
  ctx.font = "800 76px Outfit, sans-serif";
  const nameLines = wrap(ctx, data.productName || "", 600, 3);
  nameLines.forEach((l, i) => ctx.fillText(l, 72, 320 + i * 86));

  // score ring
  const cx = 840;
  const cy = 360;
  const r = 150;
  ctx.lineWidth = 26;
  ctx.lineCap = "round";
  ctx.strokeStyle = "#1A241C";
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.stroke();
  ctx.strokeStyle = accent;
  ctx.shadowColor = accent;
  ctx.shadowBlur = 30;
  ctx.beginPath();
  ctx.arc(cx, cy, r, -Math.PI / 2, -Math.PI / 2 + (Math.PI * 2 * score) / 100);
  ctx.stroke();
  ctx.shadowBlur = 0;
  ctx.fillStyle = "#F8FAF9";
  ctx.textAlign = "center";
  ctx.font = "800 108px Outfit, sans-serif";
  ctx.fillText(String(score), cx, cy + 32);
  ctx.fillStyle = "#A3B3AA";
  ctx.font = "500 24px 'IBM Plex Mono', monospace";
  ctx.fillText("/ 100 SAFETY SCORE", cx, cy + 78);
  ctx.textAlign = "left";

  // verdict
  ctx.fillStyle = "#A3B3AA";
  ctx.font = "400 34px 'IBM Plex Sans', sans-serif";
  const verdictY = 320 + nameLines.length * 86 + 20;
  wrap(ctx, data.overallVerdict || "", 936, 3).forEach((l, i) => ctx.fillText(l, 72, verdictY + i * 46));

  // traffic light counts
  const nh = data.nutritionHighlights || {};
  const counts = [
    ["red", nh.redIngredients || 0, "AVOID"],
    ["yellow", nh.yellowIngredients || 0, "CAUTION"],
    ["green", nh.greenIngredients || 0, "SAFE"],
  ];
  const boxY = 760;
  const boxW = 296;
  counts.forEach(([k, n, label], i) => {
    const x = 72 + i * (boxW + 24);
    ctx.fillStyle = "#0F1712";
    ctx.strokeStyle = "rgba(255,255,255,0.08)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.roundRect(x, boxY, boxW, 170, 22);
    ctx.fill();
    ctx.stroke();
    ctx.fillStyle = COLORS[k];
    ctx.beginPath();
    ctx.arc(x + 44, boxY + 50, 14, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = "#F8FAF9";
    ctx.font = "800 72px Outfit, sans-serif";
    ctx.fillText(String(n), x + 32, boxY + 136);
    ctx.fillStyle = "#5C6E64";
    ctx.font = "500 22px 'IBM Plex Mono', monospace";
    ctx.fillText(label, x + 78, boxY + 58);
  });

  ctx.fillStyle = "#5C6E64";
  ctx.font = "500 24px 'IBM Plex Mono', monospace";
  ctx.fillText(siteUrl.replace(/^https?:\/\//, "").toUpperCase(), 72, 1010);
  ctx.textAlign = "right";
  ctx.fillText("AI-GENERATED · NOT MEDICAL ADVICE", S - 72, 1010);

  return new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
}
